import * as React from 'react';

export class AditionReload extends React.Component {
  componentDidMount(): void {
    function timer(
      rects: NodeListOf<Element>,
      billboards: NodeListOf<Element>,
    ): void {
      setTimeout(function init(): void {
        for (const rect of rects) {
          rect.classList.toggle('hiddenAd');
        }

        for (const billboard of billboards) {
          billboard.classList.toggle('hiddenAd');
        }

        timer(rects, billboards);
      }, 10000);
    }

    const rects = document.querySelectorAll('.Adition__Container_rect');
    const billboards = document.querySelectorAll(
      '.Adition__Container_billboard',
    );

    timer(rects, billboards);
  }

  render(): React.ReactElement {
    return <div>&nbsp;</div>;
  }
}
